import type { LetterRecommendation } from '@frontend/api-types';
import { dateFormatters } from '@frontend/duck-tape';
import { HalfStamp } from '@frontend/web-icons';
import { Text, XStack, YStack } from '@frontend/web-react';
import { NavLinkWrapper } from '@frontend/web/components';

type LetterRecommendationCardProps = {
  letterRecommendation: LetterRecommendation;
  onPress: () => void;
};

export const LetterRecommendationCard = ({ letterRecommendation, onPress }: LetterRecommendationCardProps) => {
  const { createdAt, createdTasksCount, recommendationsCount, viewedAt } = letterRecommendation;

  return (
    <NavLinkWrapper
      className="border-1 border-borderPrimary p-md shadow-one relative rounded-md bg-white"
      onClick={onPress}
      to=""
    >
      <YStack gap="sm">
        <XStack alignItems="center" gap="sm">
          {!viewedAt && <YStack className="size-sm rounded-full bg-red-600" />}
          <Text className="font-caveat text-textPrimary" type="h2">
            {dateFormatters.relativeWeeksAgo(createdAt)}
          </Text>
        </XStack>
        <Text className="text-p-sm text-textTertiary">
          {recommendationsCount} suggestions {createdTasksCount ? `| ${createdTasksCount} created` : ''}
        </Text>
      </YStack>
      {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
      <YStack className="top-none absolute right-[48px]">
        <HalfStamp />
      </YStack>
    </NavLinkWrapper>
  );
};
